import { logError } from "@up/data";
import { Spinner } from "@up/ui";

import type { FormEvent } from "react";

type Props = {
  applyCoupon: (code: string) => void;
  isApplying: boolean;
};

export default function DiscountForm({ applyCoupon, isApplying }: Props) {
  const handleSubmit = async function (e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const form = e.target as HTMLFormElement;
    const formData = Object.fromEntries(new FormData(form));
    const code = formData["code"] as string;

    if (!code) {
      return;
    }

    try {
      await applyCoupon(code);
      form.reset();
    } catch (err) {
      logError({ action: "DISCOUNT_APPLY", error: err, context: { code } });
    }
  };

  return (
    <form
      className="checkout-discount-form"
      data-testid="checkout-discount-form"
      onSubmit={handleSubmit}
    >
      <input
        aria-label="coupon code"
        autoCapitalize="off"
        autoCorrect="off"
        autoComplete="off"
        className="checkout-discount-input mr-2 rounded border border-solid border-gray-400 pl-2"
        disabled={isApplying}
        name="code"
        id="coupon-code-input"
        data-testid="coupon-code-input"
        spellCheck="false"
      />
      {isApplying ? (
        <div className="flex items-center">
          <Spinner />
        </div>
      ) : (
        <button
          className="checkout-button checkout-discount-button rounded border border-solid border-gray-400 bg-white py-1 px-4"
          data-testid="coupon-submit-button"
          type="submit"
        >
          Apply
        </button>
      )}
    </form>
  );
}
